export const S3_URL = 'https://hipspot.s3.ap-northeast-2.amazonaws.com';
